import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Items from "@/pages/Items";
import Files from "@/pages/Files";
import Payments from "@/pages/Payments";
import PaymentStatus from "@/pages/PaymentStatus";
import Notifications from "@/pages/Notifications";
import AIAssistant from "@/pages/AI";
import { AdminUsers, AdminActivity } from "@/pages/Admin";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#71717A] font-mono text-sm">
        Loading...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AnonOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors theme="dark" />
          <Routes>
            <Route path="/login" element={<AnonOnly><Login /></AnonOnly>} />
            <Route path="/register" element={<AnonOnly><Register /></AnonOnly>} />
            <Route path="/forgot-password" element={<AnonOnly><ForgotPassword /></AnonOnly>} />
            <Route path="/payment/success" element={<Protected><PaymentStatus /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentStatus cancelled /></Protected>} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="items" element={<Items />} />
              <Route path="files" element={<Files />} />
              <Route path="payments" element={<Payments />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="ai" element={<AIAssistant />} />
              <Route path="admin/users" element={<AdminUsers />} />
              <Route path="admin/activity" element={<AdminActivity />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
